
import Select from 'react-select';
import { Form, Button } from "react-bootstrap";
import styles from "./ActionsColumn.module.css";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import { Tooltip } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import { useEffect } from 'react';
const ActionsColumn = (props) => {
    const data = props.data;
    const handleMatchStatus = props.handleMatchStatus;
    const updateCUP = props.updateCUP;
    const updateMatchType = props.updateMatchType;

    const matchTypeOptions = [
        {
            value: "Exact",
            label: "Exact"
        },
        {
            value: "Similar",
            label: "Similar"
        }
    ]
    let geminiStatus;
    if (data?.currentProduct?.ai_suggestion === 'approved'){
        geminiStatus = <span> Approve ({data?.currentProduct?.ai_confidence && data?.currentProduct?.ai_confidence * 100}%) {<CheckCircleRoundedIcon sx={{ color: 'rgb(25, 135, 84)' }}/>}</span>
    } else if (data?.currentProduct?.ai_suggestion === 'rejected') {
        geminiStatus = <span> Reject ({data?.currentProduct?.ai_confidence && data?.currentProduct?.ai_confidence * 100}%) {<CancelRoundedIcon sx={{ color: 'rgb(220, 53, 69)' }}/>}</span>
    } else if (data?.currentProduct?.ai_suggestion === 'manual review'){
        geminiStatus = <span> Manual Review ({data?.currentProduct?.ai_confidence && data?.currentProduct?.ai_confidence * 100}%)</span>
    }

    useEffect(() => {
        if (data?.currentProduct && !data?.currentProduct?.status){
            if (!data?.currentProduct?.match_type && data?.currentProduct?.ai_match_type){
                updateMatchType(data?.currentProduct?.ai_match_type, data?.currentProduct);
            }
            if (data?.currentProduct?.ai_cup_multiplier && data?.currentProduct?.ai_cup_multiplier !== data?.currentProduct?.cup_multiplier){
                updateCUP(data?.currentProduct?.ai_cup_multiplier, data?.currentProduct);
            }
        }
    }, [data?.currentProduct, updateMatchType, updateCUP]);

    return (
        <div style={{display: "grid", gap: "5px"}}>
            <div className={styles.ActionsColumn}>                
                <div className={styles.ActionsFormElements}> 
                    <div style={{flex: 2}}>
                        <strong>Match Type: </strong>
                    </div>
                    <div style={{flex: 3}}>
                    <Select options={matchTypeOptions}
                        value={data?.currentProduct?.match_type ? {
                            value: data?.currentProduct?.match_type,
                            label: data?.currentProduct?.match_type
                        } : null}
                        onChange={(e) => updateMatchType(e, data?.currentProduct)}
                        isClearable
                        
                        />
                    </div>
                </div>
                <div className={styles.ActionsFormElements}> 
                    <span style={{flex: 2}}>
                        <strong>CUP Multiplier: </strong>
                    </span>
                    <span style={{flex: 3}}>
                        <Form.Control type="number" value={data?.currentProduct?.cup_multiplier || ''} onChange={(e) => 
                            {
                                updateCUP(e, data?.currentProduct);
                                
                            }
                        }/>
                    </span>
                </div> 
                {data?.currentProduct?.ai_suggestion && <div className={styles.ActionsFormElements}> 
                    <span style={{flex: 2}}>
                        <strong>AI Suggestion: </strong>
                    </span>
                    <span style={{flex: 3}}>
                        {geminiStatus} {data?.currentProduct?.ai_reasoning && <Tooltip title={data?.currentProduct?.ai_reasoning}>
                            <span>
                                <InfoIcon fontSize="small" style={{ cursor: "default", color: "#666" }} />
                            </span>
                        </Tooltip>}
                    </span>
                </div> }
                <div className={styles.ActionsApprovalButtons}> 
                        <div style={{flex: 1}}>
                            <Button variant="success" style={{width: '100%'}} onClick={(e) => handleMatchStatus('approved', data?.currentProduct)}>Approve</Button>
                        </div>
                        <div style={{flex: 1}}>
                            <Button variant="danger" style={{width: '100%'}} onClick={(e) => handleMatchStatus('rejected', data?.currentProduct)}>Reject</Button>
                        </div>
                </div>
            </div>

            {(data?.currentProduct?.updated_by || data?.currentProduct?.previous_review_status) && <span><strong>Updated By:</strong> {data?.currentProduct?.updated_by || ((data?.currentProduct?.previous_review_status) && JSON.parse(data.currentProduct.previous_review_status)?.updated_by)}</span>}
            {(data?.currentProduct?.updated_at || data?.currentProduct?.previous_review_status) && <span><strong>Updated At:</strong> {data?.currentProduct?.updated_at || (data?.currentProduct?.previous_review_status && JSON.parse(data.currentProduct.previous_review_status)?.updated_at)}</span>}
        </div>

    )
};

export default ActionsColumn;